






























import Vue, { PropType } from 'vue';
import { urlFor } from '@/config/sanity';
import Story, { StoryType } from '@/models/story';

export enum StoryCardVariant {
  Default = 'default',
  Media = 'media',
  Technology = 'technology'
}

export default Vue.extend({
  name: 'StoryCard',
  props: {
    variant: {
      type: String as PropType<StoryCardVariant>,
      default: () => StoryCardVariant.Default.toString(),
      validator: (value: string) => [
        StoryCardVariant.Default.toString(),
        StoryCardVariant.Media.toString(),
        StoryCardVariant.Technology.toString(),
      ].indexOf(value) !== -1,
    },
    story: {
      type: Object as PropType<Story>,
      required: true,
    },
  },
  methods: {
    urlFor,
    onStoryClick(storySlug: string) {
      if (this.story.department === 'media' && this.story.storyType === StoryType.VideoPublication) {
        this.$router.push(`/media/${storySlug}`);
      } else {
        this.$router.push(`/saker/${storySlug}`);
      }
    },
  },
  computed: {
    shortExcerpt(): string {
      if (this.story.excerpt.length < 80) {
        return this.story.excerpt;
      }
      return `${this.story.excerpt.substring(0, 80)}...`;
    },
    shortDepartment(): string {
      if (this.story.department === 'technology') {
        return '#teknologi';
      }
      return '#media';
    },
  },
});
